import TextField from '@mui/material/TextField'
import { TranslateFunction, TranslateObjectFunction, useI18N } from '@tm/client-form/src/hooks/useI18n'
import { EmailField, TextFieldField } from '@tm/shared-lib/src/field'
import { InputProps, stringValue } from './types'

const getTextFieldLabel = (
  field: TextFieldField | EmailField,

  t: TranslateFunction,
  tt: TranslateObjectFunction
) => {
  // If labelKey is defined, use it to get the label
  if (field.labelKey) return t(field.labelKey)

  return tt(field.label)
}

export function TextFieldInput(props: InputProps<TextFieldField | EmailField>) {
  const { field, value, onChange, isSubmitting, lang } = props
  const { t, tt } = useI18N()
  const label = getTextFieldLabel(field, t, tt)
  const placeholder = 'placeholder' in field ? tt(field.placeholder) : ''
  const type = field.type === 'email' ? 'email' : 'text'

  return (
    <TextField
      value={stringValue(value)}
      onChange={event => onChange(event.target.value)}
      disabled={isSubmitting}
      fullWidth
      variant="filled"
      key={`f-${field.name}`}
      id={`f-${field.name}`}
      hiddenLabel
      placeholder={placeholder || label}
      type={type}
    />
  )
}
